import { queryStringToParams } from 'Helpers/url';

export const urls = {
    notificationsPreferences: (brand, countryCode, id) => `/api/notification-preferences/preferences/${brand}/${countryCode}/${id}`
};

const transformGetData = response => {
    return {
        data: response,
        isFetching: false,
        isError: false
    };
};

const transformRequestData = state => {
    const data = state.data ? state.data : {};

    return {
        data,
        isFetching: true,
        isError: false
    };
};

const transformPutData = (action, state) => {
    const data = Object.assign({}, state.data, queryStringToParams(action.params));

    return {
        data,
        isFetching: false,
        isError: false
    };
};

const transformErrortData = state => {
    const data = state.data ? state.data : {};

    return {
        data,
        isFetching: false,
        isError: true
    };
};

export const initialState = {
    data: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_NOTIFICATIONSPREFERENCES':
            return transformGetData(action.data);
        case 'REQUEST_NOTIFICATIONSPREFERENCES':
            return transformRequestData(state);
        case 'RESPONSE_PUT_NOTIFICATIONSPREFERENCES':
            return transformPutData(action, state);
        case 'ERROR_PUT_NOTIFICATIONSPREFERENCES':
        case 'ERROR_NOTIFICATIONSPREFERENCES':
            return transformErrortData(state);
        default:
            return state;
    }
};
